var _circle, _path, _polyline, _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSessions({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 19.5,
    r: 19.5,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2,15.05V13a1.77,1.77,0,0,1,1.48-1.76L23.16,10a2.47,2.47,0,0,1,2.05.57,2.44,2.44,0,0,1,.89,1.92V26.53a2.44,2.44,0,0,1-.89,1.92,2.47,2.47,0,0,1-2.05.57l-7.48-1.25A1.77,1.77,0,0,1,14.2,26V24",
    fill: "none",
    stroke: "#624de3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3,
    fillRule: "evenodd"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "18.14 15.38 21.98 19.52 18.14 23.66",
    fill: "none",
    stroke: "#624de3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3,
    fillRule: "evenodd"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 9.9,
    y1: 19.52,
    x2: 21.98,
    y2: 19.52,
    fill: "none",
    stroke: "#624de3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSessions);
export default __webpack_public_path__ + "static/media/sessions.78c22e6bcd20f19352cf8bf138ff1adf.svg";
export { ForwardRef as ReactComponent };